<template>
    <div class="outer-wrapper" style="text-align: center;">
    <div class="page-header clear-filter"></div>
        <div class="ls section fixedTopSpacingOrder fixedContentMobileview"
          id="hideTopSpacingDivOrder">
      <div class="container">
                <div class="row pd-top-10" style="text-align: center;">
                    <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:18px;">
  	                  <!--sanya: added css classes and padding to make this page similar to all other pages-->
            <!--sanya: changed thank you statement, mentioned subscription-->
            <h3 style = "margin: auto;">Thank You</h3>
            <p>You have successfully subscribed!</p>

            <b-row>
              <b-col align-self="center">
                <!--sanya: added table to display product details-->
                <table style = "margin: auto;">
                  <tr>
                    <th style = "font-size: 1.5em; font-weight: 400;">Your Subscription Details</th>
                  </tr>
                  <!--sanya: iterating through all products in cart-->
                  <tr 
                    v-for="item in cart" 
                    :key = "item['product_id']" 
                  >
                        <td>
                          <div>
                            <img
                          style="height:90px;width:auto; float: left; padding-right: 7%;"
                          v-bind:src= item.img
                              /> 
                          </div>
                          <div style = "text-align: left; padding-top: 7%;">
                            <div id="name">{{ item.product_name }}</div>
                            <div id="pcket">{{ item.product_quantity + " " + item.product_unit}}</div>
                            <div id = "price"> ₹{{ item.product_price }}.00</div>
                          </div>
                        </td>
                  </tr>
                  <tr>
                    <td style = "text-align: left;">Delivery starts from <b><div style = "display: inline;" id = "date"></div></b></td>
                  </tr>
                </table>
                <p>To manage your subscription download the doodhvale app.</p>
                <!--sanya: added install app button (same as main navbar)-->
                <button
                  mat-raised-button=""
                  v-on:click.prevent="goToEvents()"
                  class="mat-raised-button btn btn-info btn-md dv-install-btn"
                >
                  <span class="mat-button-wrapper" style = "font-size:1.2em !important;">Install App</span>
                  <div class="mat-button-ripple mat-ripple" matripple=""></div>
                  <div class="mat-button-focus-overlay"></div>
                </button>
                <!--sanya: removed checkout our farms button as one button feels more than enough-->
                <!-- <div class="dv-btn dv-btn-addon" fxlayoutalign="center center">
                  <button
                    mat-raised-button=""
                    v-on:click.prevent="() => $router.push('/our-farms')"
                    class="mat-raised-button btn btn-info btn-round btn-lg dv-primary-btn"
                    value=""
                  >
                    <span class="mat-button-wrapper">Checkout Our Farms</span>
                    <div
                      class="mat-button-ripple mat-ripple"
                      matripple=""
                    ></div>
                    <div class="mat-button-focus-overlay"></div>
                  </button>
                </div> -->
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// priya (analytics event)
import { firebase } from "../main";
export default {
  data() {
      return {
        cart : [],  // sanya: initialized with empty cart
        imageSrc: "" // sanya: initialized with an empty string 
      };
    },
  /*data() {
        return {
            referrerPage: null
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.referrerPage = from;
        });
    },*/
  created() {
    //window.fbq('track', 'PageView')
  },
  mounted() {
    //alert(this.referrerPage)
    /*alert("document:"+document.referrer)
    if(this.$router.internalHistory[0]){
      this.referrerPage = this.$router.internalHistory[0]

    }else{
      referrerPage = document.referrer
    }*/

    //sanya: importing cart from Index.vue
    this.cart = JSON.parse(sessionStorage.getItem("cart"));
    //sanya: importing value of start date from Index.vue
    var start_date = sessionStorage.getItem("start_date");
    document.getElementById('date').innerHTML = start_date;
    if (sessionStorage.getItem("referrerPage") != "order") {
      sessionStorage.clear();
      this.$router.push("/");
    }
    window.fbq("init", "945369542580164");
    window.fbq("track", "PageView");
    sessionStorage.clear();
  },
  metaInfo() {
    return {
      title: "Thank You - Doodhvale.com",
      meta: [
        {
          name: "description",
          content:
            "Thank you for ordering our products. Find variety of diary products such as cow milk, buffalo milk, fresh dahi, desi cow ghee online.",
        },
        // OpenGraph data (Most widely used)
        { property: "og:title", content: "Thank You - Doodhvale.com" },
        { property: "og:site_name", content: "Doodhvale" },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "Thank you for ordering our products. Find variety of diary products such as cow milk, buffalo milk, fresh dahi, desi cow ghee online.",
        },
        { property: "og:url", content: "https://www.doodhvale.com/thank-you" },
        // Twitter card
        { name: "twitter:card", content: "summary" },
        //{name: 'twitter:site', content: 'https://www.doodhvale.com/thank-you'},
        { name: "twitter:title", content: "Thank You - Doodhvale.com" },
        {
          name: "twitter:description",
          content:
            "Thank you for ordering our products. Find variety of diary products such as cow milk, buffalo milk, fresh dahi, desi cow ghee online.",
        },
        // Your twitter handle, if you have one.
        //{name: 'twitter:creator', content: '@alligatorio'}
        //{name: 'twitter:image:src', content: 'https://www.my-site.com/my-special-image.jpg'},
        //{name: 'robots', content: 'index,follow'}
      ],
      link: [{ rel: "canonical", href: "https://www.doodhvale.com/thank-you" }],
    };
  },
  // priya (analytics task)
  created() {
    this.sendEvent("website_payment_success");
  },
  methods: {
    ourFarms() {
      this.$router.push("/our-farms");
    },
    //sanya: method for install app button
    goToEvents() {
      location.href = "https://v.doodhvale.in/#/a/appLink";
    },
    // priya (analytics task)
    sendEvent(eventName) {
      firebase.logEvent(firebase.analytics, eventName);
      // console.log(eventName);
    },
  },
};
</script>

<!--sanya: added css to organise content on page-->
<style>
  p{
    text-align: center;
  }
  .dv-install-btn {
  background-color: #74c7fc !important;
  font-family: "Poppins Medium" !important;
  letter-spacing: 1px;
  padding: 10px 13px !important;
  }
</style>
